module.exports = __webpack_public_path__ + "static/img/4.1b23ae2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/4.jpg
// module id = ZRV8
// module chunks = 36